import Vue from "vue";
import App from "./App.vue";

// Element UI
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import "element-ui/lib/theme-chalk/display.css";

// Styling
import "@/assets/css/ra-main.scss";

import vueResource from "vue-resource";
import VueClipboard from "vue-clipboard2";
import VueAnalytics from "vue-analytics";

// Mixins et Directives
import "./mixins";
import "./directives";

// Global Components
import "@/components/Global/global-config.js";

// Router
import router from "./router";

// Store
import store from "./store";

import axios from "axios";
import { authToken } from "@/lib/utils";

const ifInProduction = process.env.NODE_ENV === "production";
Vue.config.productionTip = ifInProduction;
Vue.config.devtools = !ifInProduction;

const apiRoot =
  process.env.NODE_ENV !== "development" ? "" : "http://localhost:9000";
const serverUrl = `${apiRoot}/api/v1/`;

const axiosClient = axios.create({
  baseURL: serverUrl,
  transformRequest: [
    (data, headers) => {
      const presetApiToken = headers.get("Api-Token");
      const token = authToken();
      if (presetApiToken || token) {
        headers.common["Api-Token"] = presetApiToken || token;
      }
      return data;
    }
  ]
});

Vue.prototype.$http = axiosClient;

Vue.use(ElementUI, { locale });

Vue.use(vueResource);
Vue.use(VueClipboard);
Vue.use(VueAnalytics, {
  id: "UA-219106792-3"
});

Vue.http.options.root = serverUrl;
Vue.http.options.credentials = true;

// Intercepting Requests to add Loader
Vue.http.interceptors.push(request => {
  const loginUrl = "/login";
  const token = authToken();
  const presetApiToken = request.headers.get("Api-Token");
  if (presetApiToken || token) {
    request.headers.set("Api-Token", presetApiToken || token);
  }

  if (request.url.includes("auth/local/users/authenticate")) {
    request.headers.set("Api-Token", undefined);
  }

  return response => {
    // Handle Expired Access Tokens
    if (response.body.code && response.body.code === "NO_AUTH") {
      // Clean up the storage data and route to login.
      try {
        localStorage.clear();
        sessionStorage.clear();
      } catch (e) {
        return router.push(loginUrl);
      }

      router.push(loginUrl);
    }
  };
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
